<template>
	<v-main>
		<div class="bodydbg">
			<v-img :src="$root.asset(leaderboard.background)" style="width: 100%; height: auto; right: 0; bottom: 0">
				<v-container>
					<v-row>
						<v-col>
							<!--Top 3-->
							<v-card class="pa-2 mb-4 rounded-l" :style="{backgroundColor: color.backgroundColor}" v-if="topRankList && topRankList.length > 0">
								<v-row v-for="(user, index) in topRankList" v-bind:key="index" class="mx-0">
									<v-row width="100%" v-if="index < 3" class="mx-0">
										<v-col cols="10" class="pr-0" rounded>
											<v-card class="d-flex flex-row justify-center align-center rounded-xl" max-height="35px">
												<v-avatar color="grey">
													<v-img
														v-if="user.image"
														:src="
															user.firstName == $store.state.principal.firstName &&
															user.lastName == $store.state.principal.lastName
																? baseLocation + '/asset/file/user/' + $store.state.principal.image
																: baseLocation + '/asset/file/user/' + user.image
														"
													></v-img>
													<v-icon v-else size="35" color="white">mdi-account</v-icon>
												</v-avatar>
												<v-card-text class="black--text d-flex flex-row align-center">
													<b class="d-inline-block d-sm-none text-truncate" style="max-width: 100px">
														{{ user.firstName }}
														{{ user.lastName }}
													</b>
													<b class="d-none d-sm-none d-md-flex text-truncate">
														{{ user.firstName }}
														{{ user.lastName }}
													</b>
													<v-spacer></v-spacer>
													<b class="text-truncate">
														{{ user.point }}
														{{$store.state.principal.experienceId != 1362227 ? 'POINTS' : 'MILES'}}
													</b>
												</v-card-text>
											</v-card>
										</v-col>
										<v-col cols="2">
											<v-avatar color="orange darken-3" size="40">
												<span class="white--text"> {{ index + 1 }}{{ getOrdinal(index + 1) }} </span>
											</v-avatar>
										</v-col>
									</v-row>
								</v-row>
							</v-card>

							<!--Not Top 3-->
							<v-card class="pa-2" color="rgba(0,0,0,0)" style="min-width: 300px" v-if="topRankList && topRankList.length > 0">
								<v-row v-for="(user, index) in topRankList" v-bind:key="index" class="mx-0">
									<v-row width="100%" v-if="index >= 3" class="mx-0">
										<v-col cols="10" class="pr-0" rounded>
											<v-card class="d-flex flex-row justify-center align-center rounded-xl" max-height="35px">
												<v-avatar color="grey">
													<v-img
														v-if="user.image"
														:src="
															user.firstName == $store.state.principal.firstName &&
															user.lastName == $store.state.principal.lastName
																? baseLocation + '/asset/file/user/' + $store.state.principal.image
																: baseLocation + '/asset/file/user/' + user.image
														"
													></v-img>
													<v-icon v-else size="35" color="white">mdi-account</v-icon>
												</v-avatar>
												<v-card-text class="black--text d-flex flex-row align-center">
													<b class="d-inline-block d-sm-none text-truncate" style="max-width: 100px">
														{{ user.firstName }}
														{{ user.lastName }}
													</b>
													<b class="d-none d-sm-none d-md-flex text-truncate">
														{{ user.firstName }}
														{{ user.lastName }}
													</b>
													<v-spacer></v-spacer>
													<b class="text-truncate">
														{{ user.point }}
														{{$store.state.principal.experienceId != 1362227 ? 'POINTS' : 'MILES'}}
													</b>
												</v-card-text>
											</v-card>
										</v-col>
										<v-col cols="2">
											<v-avatar color="orange darken-3" size="40">
												<span class="white--text"> {{ index + 1 }}{{ getOrdinal(index + 1) }} </span>
											</v-avatar>
										</v-col>
									</v-row>
								</v-row>
							</v-card>
						</v-col>
						<v-col>
							<!--Current User Rank-->
							<v-row class="mx-0">
								<v-card class="mb-4 rounded-xl" width="100%">
									<v-col>
										<v-card-text class="font-weight-bold text-center text-h4 black--text">
											Your Position is
											<v-avatar :size=starSize tile>
												<i
													aria-hidden="true"
													class="v-icon notranslate mdi mdi-star theme--light"
													style="color: #ef6c00"
													:style="{fontSize: starFontSize + 'px'}"
												>
													<span
														style="font-size: 20px !important; display: block; position: absolute"
														class="white--text headline my-auto"
													>
														{{ userRank.position }}{{ getOrdinal(userRank.position) }}
													</span>
												</i>
											</v-avatar>
											({{ userPoint }} {{ userPoint != null ? (userPoint == 1 ?
												($store.state.principal.experienceId != 1362227 ? 'point' : 'mile') :
												($store.state.principal.experienceId != 1362227 ? 'POINTS' : 'MILES')
											) : "" }})
										</v-card-text>
									</v-col>
								</v-card>
							</v-row>
							<!---Points Information--->
							<v-row class="mx-0">
								<v-card class="mb-4 rounded-xl" width="100%">
									<v-row>
										<v-col>
											<v-card-text class="font-weight-bold text-center text-h4 orange--text pb-2"
												>HOW TO EARN {{$store.state.principal.experienceId != 1362227 ? 'POINTS' : 'MILES'}}</v-card-text
											>
											<v-card-text class="pt-0 pb-1 text-center font-weight-bold text-h5">
												The more {{$store.state.principal.experienceId != 1362227 ? 'points' : 'miles'}} you earn the more
												<br />chances you have of winning cool prizes!
											</v-card-text>
											<v-card-subtitle class="pt-0 text-center"> {{$store.state.principal.experienceId != 1362227 ? 'Points' : 'Miles'}} will be updated every 15 minutes </v-card-subtitle>
										</v-col>
									</v-row>
									<div class="ma-5">
										<v-row v-for="(pointSystem, index) in leaderboard.pointSystemList" :key="index">
											<v-col cols="12" class="pt-1 pb-1 text-center">
												<v-card-text class="pt-0 pb-1 text-center">
													<v-row>
														<v-col cols="8" class="text-left">
															<span v-if="pointSystem.title != null && pointSystem.title != ''">{{
																pointSystem.title
															}}</span>
															<div
																v-else-if="pointSystem.specificId != null && pointSystem.specificId.length > 0"
																style="display: inline-block"
															>
																{{ pointSystem.description.replace(/_/g, " ") }} -
																<span v-for="(specific, index) in pointSystem.specificId" :key="index">
																	<p
																		v-if="
																			pointSystem.description == 'Visit_room' &&
																			roomList.find((room) => room.id === specific) != null
																		"
																		style="display: inline"
																	>
																		{{ roomList.find((room) => room.id === specific).name }}
																	</p>
																	<p
																		v-else-if="
																			pointSystem.description == 'Watch_live_presentation' &&
																			livePresentationList.find(
																				(livePresentation) => livePresentation.id === specific
																			) != null
																		"
																		style="display: inline"
																	>
																		{{
																			livePresentationList.find(
																				(livePresentation) => livePresentation.id === specific
																			).title
																		}}
																	</p>
																	<p
																		v-else-if="pointSystem.description == 'Watch_presentation_video'"
																		style="display: inline"
																	>
																		{{
																			nonlivePresentationList.find(
																				(nonlivePresentation) => nonlivePresentation.id === specific
																			).title
																		}}
																	</p>
																	<p v-else style="display: inline">
																		{{ specific }}
																	</p>
																	<p v-if="index != pointSystem.specificId.length - 1" style="display: inline">
																		,&nbsp;
																	</p>
																</span>
															</div>
															<span v-else>{{ pointSystem.description.replace(/_/g, " ") }}</span>
														</v-col>
														<v-col cols="4" class="d-flex justify-end align-center orange--text font-weight-bold">
															{{ pointSystem.point }}
															{{$store.state.principal.experienceId != 1362227 ? 'POINTS' : 'MILES'}}
														</v-col>
													</v-row>
												</v-card-text>
												<v-divider v-if="index < leaderboard.pointSystemList.length - 1"></v-divider>
											</v-col>
										</v-row>
									</div>
								</v-card>
							</v-row>
							<!--Prizes-->
							<v-row class="mx-0">
								<v-card class="mb-4 rounded-xl" width="100%">
									<v-card-text class="font-weight-bold text-center text-h4 black--text pb-0">PRIZES</v-card-text>
									<v-col v-if="leaderboard.prizeDataList && leaderboard.prizeDataList.length > 0">
										<v-row
											style="margin: 0px 10px 10px 10px; align-items: center; display: flex; justify-content: center"
											v-for="(prize, idxPrize) in leaderboard.prizeDataList"
											:key="idxPrize"
										>
											<v-row
												v-if="prize.type == 'Text_and_image'"
												style="margin: 0px 10px 10px 10px; align-items: center; display: flex; justify-content: center"
											>
												<v-col cols="6">
													<h3 style="font-size: 1.25rem !important; text-align: center">{{ prize.title }}</h3>
													<p style="color: #ff9800; font-size: 0.875rem; text-align: center">{{ prize.description }}</p>
												</v-col>
												<v-col cols="6">
													<img
														v-if="prize.image && $root.isImage(prize.image)"
														:src="
															prize.image.toLowerCase().startsWith('http')
																? prize.image
																: baseLocation + '/asset/file/' + prize.image
														"
														style="max-width: 100%; max-height: 100%; height: 25.8vh !important"
													/>
												</v-col>
											</v-row>
											<v-row
												v-if="prize.type == 'Text'"
												style="margin: 0px 10px 10px 10px; align-items: center; display: flex; justify-content: center"
											>
												<v-col cols="12">
													<h3 style="font-size: 1.25rem !important; text-align: center">{{ prize.title }}</h3>
													<p style="color: #ff9800; font-size: 0.875rem; text-align: center">{{ prize.description }}</p>
												</v-col>
											</v-row>
											<v-row
												v-if="prize.type == 'URL'"
												style="margin: 0px 10px 10px 10px; align-items: center; display: flex; justify-content: center"
											>
												<a @click="openNewTab(prize.url)" style="color: #ff9800; font-size: 0.875rem; text-align: center">{{
													prize.title
												}}</a>
											</v-row>
										</v-row>
									</v-col>
									<v-col v-else>
										<v-card-subtitle class="text-center"> Currently there are no prizes </v-card-subtitle>
									</v-col>
								</v-card>
							</v-row>
						</v-col>
					</v-row>
				</v-container>
			</v-img>
		</div>
		<v-row v-if="$store.state.isPoweredBy" style="background-color: black">
			<v-col cols="12" sm="12">
				<div id="v-footer" style="height: 50px; background-color: black" v-if="$store.state.footerText === ''">
                    <p class="text-center" style="color: #cccccc;padding-top: 15px">Powered by <a href="https://v-unite.com/" target="_blank" style="color:#cccccc">V-Unite</a></p>
                </div>
                <div id="v-footer" style="height: 50px; background-color: black" v-else>
                    <p class="text-center" style="color: #cccccc;padding-top: 15px">{{ $store.state.footerText }}</p>
                </div>
			</v-col>
		</v-row>
	</v-main>
</template>
<style scoped>
.bodydbg {
	background-color: black;
	background-size: cover;
}
</style>
<script>
import axios from "axios";

export default {
	props: ["tenantSlug", "experienceSlug"],
	data() {
		return {
			topRankList: [],
			userRank: {},
			leaderboard: {},
			userPoint: null,
			baseLocation: axios.defaults.baseURL,
			roomList: [],
			livePresentationList: [],
			nonlivePresentationList: [],
			color: {
				backgroundColor: "#416D74FF",
				additionalBackgroundColor: "#3B5A5FFF",
				dateBackgroundColor: "#1E1E1EFF",
				fontColor: "#FFFFFFFF"
			},
			starSize: 100,
			starFontSize : 100
		};
	},
	mounted() {
		this.getLeaderboard();
		this.getTopRankList();
		this.getCurrentUserRank();
		this.findMe();
		this.saveActivityLog();
		this.getColor();
		if (this.$root.showLiveSupport) {
			this.$root.setCurrentUrlLiveSupport(this.$router.currentRoute.path);
		}
	},
	methods: {
		getLeaderboard() {
			axios
				.get("/system/leaderboard")
				.then((response) => {
					this.leaderboard = response.data;
					// Check if large asset is exist and use it
					let vm = this
					this.$root.isImageExist(this.$root.largeAsset(this.leaderboard.background), function(status) {
						if (status) {
							vm.leaderboard.background = vm.$root.largeAsset(vm.leaderboard.background);
						}
					});
					this.getStructureList();
					this.getNonLivePresentationList();
					this.getLivePresentationList();
				})
				.catch(() => {});
		},
		getTopRankList() {
			axios
				.get("/system/leaderboard/toprank?limit=20")
				.then((response) => {
					this.topRankList = response.data;
				})
				.catch(() => {});
		},
		getCurrentUserRank() {
			axios
				.get("/system/leaderboard/currentrank")
				.then((response) => {
					if (response.data != "") {
						this.userRank = response.data;

						let length = this.userRank.position.toString().length;
						if (length == 3) {
							this.starSize = 110;
							this.starFontSize = 130;
						} else if (length > 3) {
							this.starSize = 110 + ((length - 3) * 15);
							this.starFontSize = 130 + ((length - 3) * 20);
						}
					}
				})
				.catch(() => {});
		},
		findMe() {
			axios
				.get("/system/user")
				.then((response) => {
					this.userPoint = response.data.point;
				})
				.catch(() => {});
		},
		getOrdinal(n) {
			return n && (["st", "nd", "rd"][((((n + 90) % 100) - 10) % 10) - 1] || "th");
		},
		getStructureList() {
			axios
				.post("/system/structure/list", { experienceId: this.$store.state.principal.experienceId })
				.then((response) => {
					this.roomList = response.data;
				})
				.catch();
		},
		getLivePresentationList() {
			this.livePresentationList = [];
			axios
				.post("/system/presentation/live/list", { experienceId: this.$store.state.principal.experienceId })
				.then((response) => {
					this.livePresentationList = response.data;
				})
				.catch();
		},
		getNonLivePresentationList() {
			this.nonlivePresentationList = [];
			axios
				.post("/system/presentation/nonlive/list", { experienceId: this.$store.state.principal.experienceId })
				.then((response) => {
					this.nonlivePresentationList = response.data;
				})
				.catch();
		},
		saveActivityLog(){
			let activityLog = { type: "Visit_leaderboard" };
			this.$root.saveActivityLog(activityLog);
		},
		getColor() {
			axios
				.post("/system/experienceColors/find",{
					tenantSlug: this.tenantSlug,
					experienceSlug: this.experienceSlug,
					page: "Leaderboard"
				})
				.then(response => {
					if (response.data) {
						this.color = response.data;
					}
				})
				.catch(() => {});
		},
		openNewTab(url) {
			window.open(url, 'blank');
		}
	},
};
</script>
